import styled from 'styled-components';

export const SettingsTabViewContainer = styled.div`
  background-color: #bec3ca;
`;

export const NavTabsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0 20px;
  margin: 1px 0 0 0;
  font-size: 14px;
  background-color: #f2f3f4;
  color: var(--Grey-2-Text, #748aa1);
  font-weight: 600;
  line-height: 20px;
`;

export const NavTab = styled.li`
  padding: 10px 20px;
  cursor: pointer;

  &.active-nav-tab {
    background: #d0dcee;
    color: #2b73e0;
    font-weight: 700;
  }

  svg {
    margin-left: 4px;
    transform: rotate(180deg);
  }
`;

export const SubNavTabsWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 5px 20px;
  margin: 1px 0 0 0;
  font-size: 14px;
  background-color: #d0dcee;
  color: #748aa1;
  font-weight: 600;
  line-height: 20px;
`;

export const SubNavTab = styled.li`
  padding: 5px 20px;
  cursor: pointer;
  flex-wrap: nowrap;
  display: flex;

  &.active-sub-nav-tab {
    background-color: #e3eaf5;
  }

  .active-sub-nav-tab-text {
    color: #2b73e0;
    font-weight: 700;
  }

  .sub-nav-tab-items {
    margin-left: 2px;
  }

  .sub-nav-tab-items span:not(:last-child) {
    padding-right: 8px;
    margin-right: 8px;
    border-right: 2px solid #748aa1;
  }
`;
